import { LoadingState } from '@/components/common/feedback/LoadingState';

const FallbackSpinner = () => <LoadingState variant="fullHeight" text={'Loading page…'} />;

export default FallbackSpinner;
